module.exports = __webpack_public_path__ + "img/nav-soundcheck-on.95ebcaf4.png";